module.exports = "/_next/static/images/77ace49b8f6a66ed688a8ef9f2a34af6-bill-filling-package.png.webp";